import { Box, Typography } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../../../hooks/useRedux";
import { grey } from "@mui/material/colors";

interface Props {
  title: string;
  active: boolean;
  index: number;
  handleClick: (index: number) => void;
}

export default function TabButton({
  title,
  active,
  index,
  handleClick,
}: Props) {
  const themeMode = useAppSelector((state) => state.settings.themeMode);

  return (
    <Box
      onClick={() => handleClick(index)}
      sx={{
        cursor: "pointer",
        boxShadow: active ? "0px 2px 5px 0px rgba(0,0,0,0.2)" : "",
        color: active ? "primary.main" : "textColor.main",
        backgroundColor:
          themeMode === "light"
            ? active
              ? "white"
              : ""
            : active
            ? "primary.main"
            : "",
        borderRadius: "8px",
        padding: "8px 10px",
        textAlign: "center",
        transition: "background-color 0.2s",
        flex: "1",
      }}
    >
      <Typography
        noWrap
        sx={{
          color: active
            ? themeMode === "light"
              ? "primary.main"
              : "#fff"
            : grey[800],
          // color: themeMode === "dark" ? "#fff" : "primary.main",
          fontSize: active ? "12px" : "12px",
          fontWeight: active ? "700" : "600",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}
